import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private imgbbKey = '8d89f5ec7fb281ac9a59f8c9e08393ea';
  private binIdEn = '686c69da8561e97a50335d53';
  private binIdAr = '686c83658a456b7966bd3701';
  private accessKey = '$2a$10$YMmLxM6482Z7fJia2TIrQuHMyDPrf4wdzTDjAwufaRnxZcuRAOEd6';
  private masterKey = '$2b$10$LrtEPPMp4bIQkZYxVsn6zeVI8Cp9B8EYs.tJ3Oq1Dvfd8iC3R2uFu';

  constructor(private http: HttpClient) {}

  async uploadImage(base64: string): Promise<string | null> {
    const formData = new FormData();
    formData.append('image', base64);

    return fetch(`https://api.imgbb.com/1/upload?key=${this.imgbbKey}`, {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => data?.data?.url || null)
      .catch(() => null);
  }

  updateContent(data: any, lang: string = 'en') {
    const headers = new HttpHeaders({
      'X-Access-Key': this.accessKey,
      'X-Master-Key': this.masterKey,
      'Content-Type': 'application/json'
    });

    const binId = lang === 'ar' ? this.binIdAr : this.binIdEn;
    return this.http.put(
      `https://api.jsonbin.io/v3/b/${binId}`,
      data,
      { headers }
    );
  }

  getContent(lang: string = 'en') {
    const headers = new HttpHeaders({
      'X-Access-Key': this.accessKey
    });

    const binId = lang === 'ar' ? this.binIdAr : this.binIdEn;
    return this.http.get(
      `https://api.jsonbin.io/v3/b/${binId}/latest`,
      { headers }
    );
  }
}
